import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/shared/item_box';


function TIScreen() {
    return (
        <Fragment>
            <Head titulo="Tecnologia da Informação e Comunicação - CTIC" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1}>
                    <Col>
                        <ItemBox
                            titulo={"Termo de Adesão à Rede Nacional de Governo Digital"}
                            texto={<Fragment>Veja aqui Termo de Adesão à Rede Nacional de Governo Digital na íntegra<br /><br /></Fragment>}
                            link={"arquivos/docs/Termo-Adesao-Gov-Digital-Rj.pdf"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"RJ Digital"}
                            texto={<Fragment>Lista de municípios que aderiram ao programa RJ Digital<br /><br /></Fragment>}
                            link={"https://www.rj.gov.br/digital/rjdigitalmunicipios"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TIScreen;